import React, { useState } from 'react';
import './TestTasksTab.css';
import TestTaskTypesSubTab from './TestTaskTypesSubTab';
import TestTasksSubTab from './TestTasksSubTab';
import TestTaskTokensSubTab from './TestTaskTokensSubTab';

function TestTasksTab() {
  const [activeSubTab, setActiveSubTab] = useState('types');

  return (
    <div className="test-tasks-tab">
      <div className="sub-tabs">
        <button
          className={`sub-tab-button ${activeSubTab === 'types' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('types')}
        >
          Типы заданий
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'tasks' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('tasks')}
        >
          Тестовые задания
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'tokens' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('tokens')}
        >
          Токены доступа
        </button>
      </div>
      <div className="sub-tab-content">
        {activeSubTab === 'types' && <TestTaskTypesSubTab />}
        {activeSubTab === 'tasks' && <TestTasksSubTab />}
        {activeSubTab === 'tokens' && <TestTaskTokensSubTab />}
      </div>
    </div>
  );
}

export default TestTasksTab;
